import styled from 'foundations-theming/utils';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { Text } from 'foundations-components/components/Text';
import { updateArticle } from '../../../actions/article/UpdateArticleActions';
import sanitizeArticleHtml from '../../../utils/sanitizeArticleHtml';
import { isBodyValid } from '../../../utils/tinymceUtils';
import memoizeOne from 'react-utils/memoizeOne';
import CommandCoachingTips from 'content-assistance-lib/buttons/CommandCoachingTips';
import { getCanUseAIGeneratedContent } from '../../../selectors/contentAssistant';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "BodyEditor__Container",
  componentId: "aps4ou-0"
})([".mce-content-readonly{color:", ";cursor:not-allowed;}[class^='hs-callout-type-'],[class*=' hs-callout-type-']{border-left-style:solid;border-left-width:5px;clear:both;padding:20px 30px 10px;width:100%;}[class^='hs-callout-type-']::after,[class*=' hs-callout-type-']::after{content:'';clear:both;display:block;}.hs-callout-type-tip{background-color:#e5f5f8;border-left-color:#7fd1de;}.hs-callout-type-note{background-color:#e5f8f6;border-left-color:#7fded2;}.hs-callout-type-caution{background-color:#fdedee;border-left-color:#f8a9ad;}.hs-callout-type-warning{background-color:#ffebe6;border-left-color:#e68250;}"], ({
  theme
}) => theme.color['do-not-use-battleship']);
const importTinyMCE = () => import( /* webpackChunkName:"KbTinyMCE" */'./KbTinyMCE').then(m => m.default);
const I18nKey = key => `knowledgeContentUI.edit.fields.articleBody.${key}`;
class BodyEditor extends Component {
  constructor(props) {
    super(props);
    this.handleBlur = event => {
      if (typeof this.props.onBlur === 'function') {
        this.props.onBlur(event);
      }
    };
    this.handleChange = (event, editor) => {
      this.updateArticleBodyAndLabel(editor);
    };
    this.handleFocus = event => {
      if (typeof this.props.onFocus === 'function') {
        this.props.onFocus(event);
      }
    };
    this.handleKeyUp = (event, editor) => {
      this.updateArticleBodyAndLabel(editor);
    };
    this.getLoadableTinyMCE = memoizeOne(initialContent => Loadable({
      delay: 0,
      loader: importTinyMCE,
      LoadingComponent: () => /*#__PURE__*/_jsx("div", {
        style: {
          position: 'relative',
          cursor: 'wait'
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "article-body",
          dangerouslySetInnerHTML: {
            __html: sanitizeArticleHtml(initialContent)
          }
        })
      })
    }));
    this.state = {
      initialContent: props.article.values.hs_body,
      showLabel: !isBodyValid(props.article.values.hs_body)
    };
  }
  updateArticleBodyAndLabel(editor) {
    const bodyContent = editor.getContent();
    this.props.updateArticle(this.props.article, {
      values: {
        hs_body: bodyContent
      }
    });
    const shouldShowLabel = !isBodyValid(bodyContent);
    if (shouldShowLabel !== this.state.showLabel) {
      this.setState({
        showLabel: shouldShowLabel
      });
    }
  }
  render() {
    const {
      className,
      gates,
      readOnly,
      scopes,
      canUseAIGeneratedContent
    } = this.props;
    const {
      initialContent,
      showLabel
    } = this.state;
    const TinyMceWrapper = this.getLoadableTinyMCE(initialContent);
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Container, {
        className: "tinymce-body-container m-x-auto",
        children: [canUseAIGeneratedContent && /*#__PURE__*/_jsx(CommandCoachingTips, {
          attachTo: ".tinymce-body-container",
          placement: "top right"
        }), showLabel && /*#__PURE__*/_jsxs(Text, {
          typography: "body-200",
          color: "text-core-subtle",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: I18nKey('label')
          }), " *"]
        }), /*#__PURE__*/_jsx(TinyMceWrapper, {
          className: className,
          gates: gates,
          scopes: scopes,
          initialContent: initialContent,
          onChange: this.handleChange,
          onKeyUp: this.handleKeyUp,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          readOnly: readOnly
        })]
      })
    });
  }
}
BodyEditor.propTypes = {
  canUseAIGeneratedContent: PropTypes.bool.isRequired,
  className: PropTypes.string,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof List' is not assignable t... Remove this comment to see the full error message
  gates: PropTypes.instanceOf(Immutable.List).isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof List' is not assignable t... Remove this comment to see the full error message
  scopes: PropTypes.instanceOf(Immutable.List).isRequired,
  updateArticle: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  const {
    articleContentInfo: {
      article
    },
    auth: {
      gates,
      scopes
    }
  } = state;
  return {
    article,
    gates,
    scopes,
    canUseAIGeneratedContent: getCanUseAIGeneratedContent(state)
  };
};
const mapDispatchToProps = {
  updateArticle
};
export default connect(mapStateToProps, mapDispatchToProps)(BodyEditor);